import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Subscribe from "./Subscribe";

function PressKit() {
  return (
    <>
      <Navbar />
      <div className="container ">
        <div className="col text-center col-md-center py-4 ">
          <div className="col">
            <p className="fs-1">THE PRESS KIT</p>
          </div>
          <div className="col py-4">
            <p>
              Our press kit below includes all the information you need in order
              to cover our story. Please get in touch if you need additional
              information!
            </p>
          </div>
        </div>
        <div className="row py-5 g-0">
          <div className="col-lg-6 col-md-12 ">
            <img
              className="w-100"
              src="https://static.wixstatic.com/media/nsplsh_7344756b5a5a5a31555267~mv2_d_3000_2003_s_2.jpg/v1/fill/w_480,h_520,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Image%20by%20Kotagauni%20Srinivas.jpg"
              alt="press-kit"
            />
          </div>
          <div
            className="col-lg-6 col-md-12 px-4 "
            style={{ backgroundColor: "rgba(238,224,224)" }}
          >
            <div className="col mt-5  ">
              <p className="fs-3">NEED MORE DETAILS?</p>
            </div>
            <div className="col mt-5">
              <p>
                NEED MORE DETAILS? Write to us for a comprehensive company
                profile or get hold of our portfolio of technologies. We will be
                more than happy to setup a brief interaction with our team to
                check your requirements and provide feedback on how our
                technology can help make a difference!
              </p>
            </div>
            <div className="col">
              <a href="mailto:admin@vertoxlabs.com">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
}

export default PressKit;
